// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__OPk1m","emails":"CreateEditClinics_emails__24m-X","emailTagLabel":"CreateEditClinics_emailTagLabel__1RKdy"};